module.exports = __webpack_public_path__ + "static/img/2areaA_42.64ac948.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/2areaA_42.png
// module id = 1030
// module chunks = 1